import { createContext } from 'react';

export const ContextObjId = createContext<number|null>(null);